// 飞行操作
export default {
    time: 'Time',
    deviceName: 'Device Name',
    deviceSN: 'Device SN',
    operationContent: 'Operation Content',
    operationUser: 'Operation User',
}